import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';
import { ApiService } from './api.service';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class VisitorTrackingService {
  private visitorId: string = '';

  constructor(private apiService: ApiService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { this.initializeVisitorIdFP(); }




  trackEmailClick() {
    const paramsObj = this.getUrlParams();
    if (!!paramsObj['token']) {
      console.log('Email clicked');
      this.apiService.trackEmailClick(paramsObj).subscribe(res => {
        console.log('response', res);

      });
    }
  }



  getUrlParams(): Record<string, string> {
    const params: Record<string, string> = {};
    if (isPlatformBrowser(this.platformId)) {
      const urlObj = new URL(location.href);
      urlObj.searchParams.forEach((value, key) => {
        params[key] = value;
      });
    }
    return params;
  }




  private async initializeVisitorIdFP(): Promise<void> {
    if (isPlatformBrowser(this.platformId)) {
      const storedId = localStorage.getItem('visitorId');
      if (storedId) {
        this.visitorId = storedId;
      } else {
        this.visitorId = uuidv4();
        localStorage.setItem('visitorId', this.visitorId);
      }
      this.trackVisit();
    }
  }

  trackVisit(): void {
    const referrer = document.referrer; // Get the referrer URL
    const isOrganic = this.isOrganicVisit(referrer); // Check if it's an organic visit

    const payload = {
      visitor_id: this.visitorId,
      referrer,
      is_organic: +isOrganic,
      timestamp: new Date().toISOString(),
    };
    this.apiService.visitorInfo(payload).subscribe(res => {
      // console.log(res);
    })
  }



  private isOrganicVisit(referrer: string): boolean {
    if (!referrer) return false;

    // List of known search engine domains
    const searchEngines = [
      'google.com',
      'bing.com',
      'yahoo.com',
      'duckduckgo.com',
      'baidu.com',
      'yandex.com',
    ];

    return searchEngines.some((domain) => referrer.includes(domain));
  }




  trackEvent(event: { action: string; type: string; value?: string, pathname?: string }): void {
    const payload = {
      visitorId: this.visitorId,
      action: event.action,
      type: event.type,
      value: event.value || '',
      timestamp: new Date().toISOString(),
      path_name: event.pathname,
    };

    this.apiService.visitorEvents(payload).subscribe(res => {
      // console.log(res);
    })
  }
}
